import { Tooltip } from 'antd';
import { IconAi, IconCalling, IconOnline } from 'assets/appointment';
import { APPOINTMENT_SOURCE_TYPE } from 'constants/calendar';
import React from 'react';
import { IAppointmentItemData } from 'types/appointment';

export type AppointmentSourceKind = 'ai' | 'online' | 'calling';

/**
 * Which source icon an appointment card shows. An AI receptionist booking replaces the globe
 * (never both). Without the flag (older backend) or when false, the old rule applies:
 * bookingType 0 = call-in, anything else = online.
 */
export const getAppointmentSourceKind = (data: Pick<IAppointmentItemData, 'sourceType' | 'bookedByAi'>): AppointmentSourceKind => {
  if (data.bookedByAi) return 'ai';
  return data.sourceType !== APPOINTMENT_SOURCE_TYPE.CALl_IN ? 'online' : 'calling';
};

export const AI_BOOKING_TOOLTIP = 'Booked by AI Receptionist';

export const AppointmentSourceIcon = ({ data }: { data: Pick<IAppointmentItemData, 'sourceType' | 'bookedByAi'> }) => {
  const kind = getAppointmentSourceKind(data);
  if (kind === 'ai') {
    return (
      <Tooltip title={AI_BOOKING_TOOLTIP}>
        {/* Fill the icon slot so the svg's 100% sizing from the card CSS still applies through the wrapper. */}
        <span style={{ display: 'inline-flex', width: '100%', height: '100%' }} aria-label={AI_BOOKING_TOOLTIP}><IconAi /></span>
      </Tooltip>
    );
  }
  return kind === 'online' ? <IconOnline /> : <IconCalling />;
};
